import type { ContentSection } from './types';

export const articleSections: Record<string, ContentSection[]> = {
  'dingji-liuliang-luyin-fengbo': [
    {
      heading: '这段录音为什么会被反复讨论',
      paragraphs: [
        '事件真正让人困惑的地方，不是录音里说了什么，而是它出现的方式。第一版音频只有 28 秒，句与句之间的气口明显不连贯，最关键的半句话被一刀切在中间。也正是这半句话，成了后续所有解读的起点。',
        '第二版完整音频出现后，很多人以为事情会立刻清楚，结果恰好相反：完整版本里，那半句话的语境完全不同，前后的对话把它拉回了另一层意思。于是争论从「说了没有」变成了「你到底剪了什么」。',
      ],
    },
    {
      heading: '两次改口之间发生了什么',
      paragraphs: [
        '工作室的第一份声明措辞强硬，直接否定了录音的真实性，但没有逐段说明剪辑点在哪里。这给了二次解读很大的空间——在没有对照版本的情况下，任何一方都可以声称对方的版本被动过手脚。',
        '第二份回应明显温和了许多，开始承认「部分片段与实际情况存在出入」，这就等于默认了录音里有真实内容。措辞的转变本身，被不少读者视为比音频更值得研究的部分。',
      ],
    },
    {
      heading: '目前仍然没有答案的三个点',
      paragraphs: [
        '第一，28 秒版本的发布者是谁，至今没有可验证的公开身份。第二，完整音频的补发者声称「来自同一信源」，但没有提供任何佐证。第三，被删除的粉丝长文里提到的时间点，与两版音频都无法完全对齐。',
        '在以上三点水落石出之前，任何一方给出的结论都只能算推测。我们把素材与时间点如实列出，方便你自己判断。',
      ],
    },
  ],
  'zhibo-daihuo-shuju-yiyun': [
    {
      heading: '战报上的数字是怎么来的',
      paragraphs: [
        '官方战报主打「单场 GMV 破亿」，这个数字通常由下单金额累加得出，并不等于最终结算收入。也就是说，哪怕大量订单在付款后集中退款，战报上的数字依然可以很好看。',
        '前员工给出的两张截图，恰恰指向这一点：一张显示某个时间段订单密集生成，另一张显示同一批订单在深夜集中退款。两张图拼起来，才构成了「注水」的质疑。',
      ],
    },
    {
      heading: '机构回应留下的模糊地带',
      paragraphs: [
        '机构称截图「并非后台原始数据」，但始终没有给出原始流水或第三方审计。在数据类争议里，这几乎是最常见的应对方式——否认来源，却回避内容。',
        '对于读者来说，判断的关键在于：谁能提供可交叉验证的完整数据。只要这一点没做到，质疑就不会真正消失。',
      ],
    },
  ],
  'qiye-gaoguan-qunliao-waixie': [
    {
      heading: '截图里被忽略的三处细节',
      paragraphs: [
        '大部分转发都在讨论聊天内容涉及的人事调整，但真正让这份截图站不住脚的，是三个技术细节：其中两张的头像边缘有明显锯齿，聊天框圆角半径与其他张不一致，还有一处时间戳的分钟位数没有对齐。',
        '这些细节单独看都可能被解释为压缩损耗，但三处同时出现在同一组截图里，概率并不高。',
      ],
    },
    {
      heading: '为什么公司选择不回应该截图',
      paragraphs: [
        '公司发布了一份人事安排公告，只谈安排本身，完全不提截图真伪。这是一种常见策略：如果截图是假的，回应反而会放大传播；如果截图是真的，沉默则能拖过热度周期。',
        '对读者而言，公告与截图是两条平行信息，把他们强行关联或强行否定，都缺乏依据。',
      ],
    },
  ],
  'dianjing-xuanshou-daidap': [
    {
      heading: '所谓「操作异常」是怎么被发现的',
      paragraphs: [
        '质疑者把训练赛录像逐帧拆开，重点看镜头拉动的平滑度和快捷键释放节奏。他们主张，存在三处操作与选手过往几千小时录像里的习惯明显不同——尤其是鼠标落点，短时间内的处理速度差了一截。',
        '这类分析在电竞圈并不罕见，难点在于「习惯」本身就受状态影响，靠感觉定性很容易误伤。',
      ],
    },
    {
      heading: '设备日志为什么能推翻质疑',
      paragraphs: [
        '俱乐部公布的设备输入日志显示，整场比赛外设 ID 未发生变化，键鼠固件版本也与选手日常使用一致。换句话说，即使操作风格有波动，输入设备始终是同一套。',
        '联盟随后以日志为主要依据认定不存在代打。这提醒我们：在证据链里，可验证的客观记录，永远比主观感受更有分量。',
      ],
    },
  ],
  'lianxishi-jieyue-fengbo': [
    {
      heading: '两份聊天记录为什么会互相矛盾',
      paragraphs: [
        '两份记录来自同一段对话，但先后顺序完全不同。练习生方放出的版本里，排练通知在前、拒绝在后；公司方的版本则把拒绝排在了通知之前。只要调整一张截图的起点，整段对话的叙事就变了。',
        '这是聊天记录类争议的核心难题：截图可以被裁剪，但完整记录往往只有一方掌握。',
      ],
    },
    {
      heading: '合约条款为什么反而没人细看',
      paragraphs: [
        '真正有法律意义的，其实是合约里关于解约赔偿与培养成本结算的条款。但这部分内容被打了码，讨论度远低于聊天记录。',
        '在情绪化的传播里，越硬的信息越难看懂，也越容易被忽略。',
      ],
    },
  ],
  'tiyu-mingxing-xingcheng': [
    {
      heading: '行程表和公开赛程对不上的三天',
      paragraphs: [
        '把表格内容与官方赛程公示并排比对，会发现有三天完全冲突：表格显示选手在外地，但官方公示的比赛安排要求他留在驻地。要么表格是假的，要么公示有问题，两者不可能同时成立。',
        '除此之外，表格里还包含疑似航班信息，这类内容一旦涉及个人隐私，就不应该继续传播。',
      ],
    },
    {
      heading: '这类传闻应该如何被看待',
      paragraphs: [
        '一张没有来源的行程表，其实不具备任何证明力。它更像一颗种子——真正让它长大的，是后续各种「偶遇」版本带来的心理暗示。',
        '在没有当事人回应、也没有可验证信源的情况下，把它当成事实来讨论，对任何一方都不公平。',
      ],
    },
  ],
  'wangkong-lianai-shijianxian': [
    {
      heading: '同款背景不等于同一时段',
      paragraphs: [
        '四组所谓「同款背景」里，有三组只是桌椅、窗帘、绿植这类常见元素相似，并不构成同一地点。唯一一组连墙面纹理都对得上的，时间相差了近两个月。',
        '也就是说，这些图片能说明他们去过相似的场所，但说明不了他们什么时候一起去过。',
      ],
    },
    {
      heading: '取关顺序为什么成了关键证据',
      paragraphs: [
        '相对于照片，公开关注列表的变化是更难造假的：谁先取关、间隔多久，都可以从公开页面上核对。这一次双方几乎在同一时段取关，成为时间线上少数确定无疑的节点。',
        '事件最终停留在公开互动层面，双方未作回应，本条档案已归档。',
      ],
    },
  ],
  'shangye-jingzheng-ppt': [
    {
      heading: '一份「太专业」的爆料反而更可疑',
      paragraphs: [
        '这份 PPT 有统一的配色、完整的目录，甚至还有脚注页码。看起来非常专业，但恰恰是这份专业，成了疑点：页脚编号从 12 直接跳到 14，中间缺了一页，说明它并非完整文件的原始导出。',
        '同时，首发的三个群在十分钟内同时出现同一文件，这种同步更像是被安排了投放。',
      ],
    },
    {
      heading: '数据争议应该看什么',
      paragraphs: [
        '被指公司的回应附了一份数据说明，逐条否认了 PPT 里的结论。到这里，双方各有说法，谁也没能提供第三方审计。',
        '在商业数据争议中，唯一有决定性的证据是审计或监管文件。在此之前，所有 PPT 与回应都只能算立场表达。',
      ],
    },
  ],
  'yiren-xiaohao-yiyun': [
    {
      heading: '四条「证据」里藏着什么',
      paragraphs: [
        '推理帖给出的四条证据依次是：点赞时间与行程重合、头像缓存残留、评论用词习惯、以及一个模糊的 IP 归属地。前三条都依赖主观判断，唯一看似客观的是 IP，但那恰恰是最容易被误读的一项。',
        'IP 归属地只能定位到省级区间，且受运营商出口影响，用来说明「是同一个人」远远不够。',
      ],
    },
    {
      heading: '为什么这条档案被标记为「存疑」',
      paragraphs: [
        '整条推理链的关键一环——账号与艺人之间的直接关联——始终没有公开来源。工作室也已否认关联。',
        '因此我们把状态标为待回应，并把最重要的素材标记为「待核实」，提醒读者不要把它当成已经成立的事实。',
      ],
    },
  ],
  'hangye-shuijun-taolu': [
    {
      heading: '三段式传播：首发、搬运、解读',
      paragraphs: [
        '复盘三次事件后，一个稳定的结构浮现出来：先是某个小号在深夜首发，内容通常零碎但足够抓眼球；接着在 30 到 90 分钟内，一批账号以几乎相同的标题搬运；最后是所谓的「解读号」，用推测补上首发缺失的细节。',
        '这个顺序不是巧合。首发的模糊，恰恰是给后续解读留出加工空间；而搬运的密集，是为了让话题迅速形成体量。',
      ],
    },
    {
      heading: '普通读者可以怎么识别',
      paragraphs: [
        '第一，看最早发布者的历史内容，如果此前全是无关转发，突然出现独家爆料，就要留心。第二，对比不同账号的标题，高度雷同往往意味着同一批次投放。第三，也是最关键的，把「确定信息」和「推测部分」分开看，只要一条内容里推测占了大半，就先别急着下结论。',
      ],
    },
  ],
};